import type { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getApiShipmentsByIdOptions } from '@/api';
import { Alert, Dialog, Skeleton } from '@/ui';

import { resolveApiErrorMessage } from '../../lib/apiError';
import { ShipmentEditorDialog } from './ShipmentEditorDialog';

/*
 * Правка из списка: у строки списка нет строк отгрузки, поэтому сначала
 * подтягивается карточка, затем открывается обычное окно правки. Карточка берётся
 * из кеша, если её уже открывали.
 */

export interface EditShipmentDialogProps {
  shipmentId: string;
  onClose: () => void;
}

export const EditShipmentDialog: FC<EditShipmentDialogProps> = ({
  shipmentId,
  onClose,
}) => {
  const details = useQuery(
    getApiShipmentsByIdOptions({ path: { id: shipmentId } }),
  );

  if (details.data !== undefined)
    return <ShipmentEditorDialog shipment={details.data} onClose={onClose} />;

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title="Отгрузка: правка"
    >
      {details.isError ? (
        <Alert tone="error">
          Не удалось загрузить отгрузку: {resolveApiErrorMessage(details.error)}
        </Alert>
      ) : (
        <div className="flex flex-col gap-2.5">
          <Skeleton className="h-[34px]" />
          <Skeleton className="h-24" />
        </div>
      )}
    </Dialog>
  );
};
